import SvgIcon from "./Icon";
import { ReactComponent as SalutioRed } from '../assets/icons/salutiored.svg';

const Cargando = ({ message, altura = null }) => {
    const height = altura ? altura : "calc(100vh - 18em)";

    return (
        <div className="flex flex-col justify-center items-center" style={{ minHeight: height }}>
            <span className="flex flex-col justify-center items-center">
                <SvgIcon Icon={SalutioRed} className={"w-12 h-12 text-[#205087ff] animate-spin"} />
                <p className="mt-2 text-lg text-[#6e787aff] animate-bounce">{message || 'Cargando...'}</p>
            </span>
        </div>
    )
}

export default Cargando;